import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allTests: [],
};

const getters = {
  GET_ALL_TESTS: (state) => state.allTests,
};

const mutations = {
  SET_ALL_TESTS: (state, payload) => (state.allTests = payload),

  SET_TESTS: (state, payload) => (state.allTests = state.allTests.concat(payload)),

  PUSH_TEST: (state, payload) => (state.allTests = [...state.allTests, ...payload]),

  UPDATE_TEST: (state, payload) =>
    (state.allTests = state.allTests.map((el) => (el.id === payload.id ? payload : el))),

  DELETE_TEST: (state, id) =>
    (state.allTests = state.allTests.filter((el) => el.id !== id)),
};

const actions = {
  async REGISTER_TEST({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post(`/quality/test`, payload);
      //FOR TESTING
      // console.log(response.data)
      commit("PUSH_TEST", response.data.test);
      return;
    } catch (error) {
      //    console.log(JSON.stringify(error))
      return error.message.includes("422") ? 422 : error;
    }
  },

  async SHOW_TESTS({ commit }, page) {
    try {
      if (!page) {
        const response = await PbxHttpClient.get(`/quality/test`);
        commit("SET_ALL_TESTS", response.data.data);
        return response.data;
      } else {
        const response = await PbxHttpClient.get(`/quality/test?page=${page}`);
        //Compare if response items already exists in store
        const testStr = JSON.stringify(state.allTests);
        const resStr = JSON.stringify(response.data.data);
        if (!testStr.includes(resStr.substring(1, resStr.length - 1)))
          commit("PUSH_TEST", response.data.data);
        return response.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async EDIT_TEST({ commit }, { id, ...payload }) {
    try {
      const response = await PbxHttpClient.put(`/quality/test/${id}`, payload);
      // console.log(response.data)
      commit("UPDATE_TEST", response.data.test);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_TEST_QUESTION({ commit }, { id, ...payload }) {
    try {
      const response = await PbxHttpClient.put(
        `/quality/supervisor/test/update/${id}`,
        payload
      );
      // console.log(response.data)
      commit("UPDATE_TEST", response.data.test);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_TEST({ commit }, id) {
    try {
      const response = await PbxHttpClient.delete(`/quality/test/${id}`);
      commit("DELETE_TEST", id);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
